export enum TeamListSort {
  Title = 'Title',
  Total = 'Total',
}

export interface IEditTeamData {
  title: string;
}
